<template lang="pug">
  CommonSection(title="Описание прав" :back="{ title: company.name, name: 'company-list', params: { companyId: $route.params.companyId } }")
    .company-access-description
      FormBlock
        h2 Руководитель компании
        h3 Личные проекты
        ul
          li Может создавать личные проекты вне компании в рамках своего тарифа. Эти проекты видны только ему лично.
          li Количество личных проектов и доступный объём файлового хранилища определяются его тарифом. Подробнее о тарифах:&nbsp;
            router-link(:to="{ name: 'tariffs' }") https://teroom.ru/personal/tariffs
        h3 Компании
        ul
          li Может создавать несколько компаний на своём аккаунте и переключаться между ними.
          li Компания создаётся в рамках его тарифа. Количество проектов в компании и доступный объём файлового хранилища определяются тарифом руководителя.
          li Может создавать, называть, переименовывать, редактировать и удалять отделы в любой своей компании.
          li Может полностью администрировать структуру компании и её отделов.
        h3 Проекты в компании
        ul
          li Видит все проекты своей компании.
          li Может создавать проекты в любом отделе компании.
          li Может создавать и полностью администрировать любые проекты компании: приглашать любых участников (из личных контактов или из числа сотрудников компании).
          li Может архивировать любые проекты компании.
          li Может чистить файловую систему любого проекта компании.
          li Может создавать и редактировать любые шаблоны проектов компании.
        h3 Участники компании
        ul
          li Видит структуру и всех сотрудников компании полностью (по вертикали: от руководителя до рядового сотрудника).
          li Может приглашать любых сотрудников в компанию. На этапе приглашения в компанию назначается (или редактируется) роль и должность участника.
          li Может назначать и удалять себе заместителей (одного или нескольких).
          li Может назначать и удалять руководителей отделов, менеджеров проектов и рядовых сотрудников.
          li Может назначать роли участников, которые будут отображаться во всех проектах компании (помимо автоматически присваиваемой должности).
          li При удалении любого сотрудника компании (заместитель, руководитель отдела, менеджер, рядовой сотрудник) он автоматически удаляется из всех проектов компании.
        h3 Файлы и архив
        ul
          li Полный доступ к файловой системе всех проектов компании, включая возможность очистки.
          li Может управлять архивом проектов компании.
        h3 Тарифы и оплата
        ul
          li Только руководитель компании может сменить тариф.
          li Оплатить тариф может как руководитель, так и его заместитель.
          li Подробнее о тарифах:&nbsp;
            router-link(:to="{ name: 'tariffs' }") https://teroom.ru/personal/tariffs

      FormBlock
        h2 Заместитель руководителя компании
        h3 Личные проекты
        ul
          li Может создавать личные проекты вне компании в рамках своего тарифа. Эти проекты видны только ему лично.
          li Количество личных проектов и доступный объём файлового хранилища определяются его тарифом. Подробнее о тарифах:&nbsp;
            router-link(:to="{ name: 'tariffs' }") https://teroom.ru/personal/tariffs
        h3 Проекты в компании
        ul
          li Видит все проекты и задачи компании.
          li Может создавать и полностью администрировать новые проекты в любом отделе компании: приглашать любых участников (из личных контактов или из числа сотрудников компании).
          li Может архивировать проекты компании.
          li Может чистить файловую систему проектов компании.
          li Может создавать и редактировать шаблоны проектов компании.
          li Его собственные проекты в составе компании также видны и доступны для администрирования руководителю компании.
        h3 Структура компании
        ul
          li Видит всю структуру компании и всех сотрудников (по вертикали: от руководителя до рядового сотрудника).
          li Может создавать новые отделы и назначать руководителей отделов.
          li Может полностью администрировать отделы и их участников.
        h3 Участники компании
        ul
          li Может приглашать новых участников компании в контакты.
          li Может назначать роли участников, которые будут отображаться во всех проектах компании (помимо автоматически присваиваемой должности).
          li При удалении любого сотрудника компании (заместитель, руководитель отдела, менеджер, рядовой сотрудник) он автоматически удаляется из всех проектов компании.
        h3 Ограничения
        ul
          li Не видит личные проекты руководителя компании.
        h3 Файлы и архив
        ul
          li Полный доступ к файловой системе всех проектов компании, включая возможность очистки.
          li Может управлять архивом проектов компании.
        h3 Тарифы и оплата
        ul
          // li Может оплатить тариф компании.
          li Сменить тариф компании может только руководитель.
          li Подробнее о тарифах:&nbsp;
            router-link(:to="{ name: 'tariffs' }") https://teroom.ru/personal/tariffs
      FormBlock
        h2 Руководитель отдела
        h3 Личные проекты
        ul
          li Может создавать личные проекты вне компании в рамках своего тарифа. Эти проекты видны только ему лично.
          li Количество личных проектов и доступный объём файлового хранилища определяются его тарифом. Подробнее о тарифах:&nbsp;
            router-link(:to="{ name: 'tariffs' }") https://teroom.ru/personal/tariffs
        h3 Проекты в компании
        ul
          li Видит все проекты и задачи своего отдела.
          li Может создавать и полностью администрировать новые проекты в своём отделе: приглашать любых участников отдела или из собственных личных контактов.
          li Может архивировать проекты своего отдела.
          li Может чистить файловую систему проектов своего отдела.
          li Может создавать и редактировать шаблоны проектов своего отдела.
          li Его собственные проекты в составе компании видны и доступны для администрирования руководителю компании и его заместителю.
        h3 Структура компании и участники
        ul
          li Видит структуру и всех сотрудников компании полностью (по вертикали: от руководителя до рядового сотрудника).
          li Может полностью администрировать свой отдел и его участников.
          li Может назначать роли участникам своего отдела, которые будут отображаться во всех проектах отдела (помимо автоматически присваиваемой должности).
          li При удалении любого сотрудника из его отдела (менеджер, рядовой сотрудник) он автоматически удаляется из всех проектов компании.
        h3 Ограничения
        ul
          li Не видит проекты смежных отделов.
          li Не видит личные проекты руководителя компании и заместителя.
        h3 Файлы и архив
        ul
          li Полный доступ к файловой системе проектов своего отдела, включая возможность очистки.
          li Может управлять архивом проектов своего отдела.
      FormBlock
        h2 Менеджер проектов
        h3 Личные проекты
        ul
          li Может создавать личные проекты вне компании в рамках своего тарифа. Эти проекты видны только ему лично.
          li Количество личных проектов и доступный объём файлового хранилища определяются его тарифом. Подробнее о тарифах:&nbsp;
            router-link(:to="{ name: 'tariffs' }") https://teroom.ru/personal/tariffs
        h3 Проекты в компании
        ul
          li Может создавать и полностью администрировать новые проекты в своём отделе: приглашать любых участников компании или из собственных личных контактов.
          li Видит только свои собственные проекты в отделе.
          li Может архивировать собственные проекты.
          li Может чистить файловую систему собственных проектов.
          li Может создавать и редактировать свои шаблоны проектов в отделе.
          li Его собственные проекты в составе компании видны и доступны для администрирования руководителю отдела, заместителю руководителя и руководителю компании.
        h3 Структура компании и участники
        ul
          li Видит структуру и всех сотрудников компании полностью (по вертикали: от руководителя до рядового сотрудника).
          li Может приглашать в свои проекты любых участников из компании или из личных контактов.
          li При удалении любого сотрудника из его отдела он автоматически удаляется из всех проектов компании.
        h3 Ограничения
        ul
          li Не видит проекты смежных менеджеров своего отдела и проекты смежных отделов.
          li Не видит личные проекты руководителя компании, заместителя и руководителя отдела.
        h3 Файлы и архив
        ul
          li Полный доступ к файловой системе собственных проектов, включая возможность очистки.
          li Может управлять архивом собственных проектов.
      FormBlock
        h2 Сотрудник компании
        h3 Личные проекты
        ul
          li Может создавать личные проекты вне компании в рамках своего тарифа. Эти проекты видны только ему лично.
          li Количество личных проектов и доступный объём файлового хранилища определяются его тарифом. Подробнее о тарифах:&nbsp;
            router-link(:to="{ name: 'tariffs' }") https://teroom.ru/personal/tariffs
        h3 Проекты в компании
        ul
          li Участвует в проектах компании, в которые его пригласили.
          li Работает в задачах, которые ему назначены.
          li Не имеет прав на создание, администрирование или архивирование проектов компании.
        h3 Структура компании и участники
        ul
          li Видит структуру компании по вертикали: своего руководителя отдела, заместителя руководителя компании, руководителя компании и свой отдел со всеми участниками.
          li Не имеет прав на управление отделом или участниками.
        h3 Ограничения
        ul
          li Не видит проекты, в которых не участвует.
        h3 Файлы и архив
        ul
          li Работает с файлами только в рамках задач, в которых участвует.
          li Не имеет прав на управление файловой системой или архивом проектов компании.
</template>
<script>
import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
export default {
  name: 'CompanyAccessDescriptionPage',
  components: {FormBlock, CommonSection },
  computed: {
    company() { return this.$store.getters['company/withMembers']; },
  },
};
</script>

<style lang="scss" scoped>
  .company-access-description {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }
  h2 {
    font-size: 26px;
    margin-bottom: 20px;
    &:not(:first-child) {
      margin-top: 20px;
    }
  }
  h3 {
    font-size: 18px;
    margin-bottom: 15px;
  }
  ul {
    padding-left: 20px;
    margin-bottom: 20px;
    font-weight: 400;
  }

  a {
    color: #4AA9FD !important;
  }
</style>
